import axios from 'axios'
import * as types from './mutation-types'
import noticesApi from '../../endpoints/notices'
import store from '@/store'

export const actions = {

    async getNotices({ commit, dispatch, getters, rootGetters }, payload) {

        commit(types.GET_NOTICES_LOADING)

        const { data } = await noticesApi.getNotices(payload)

        if (data.data.hcode === "ko") {
            commit(types.GET_NOTICES_ERROR, { error: error, data: null })
            return
        }

        commit(types.GET_NOTICES_COMPLETE, data.data.data)    

        return data

    }

}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/notices/actions.js
// module id = null
// module chunks = 